import dateformat from "dateformat";
import constants from "Resources/config/constants";
import { message, trans } from "Resources/plugins/i18n";
import store from "Resources/store";
import api from "Resources/util/api";

// axios က timeout ကျော်တဲ့ request ကို ဒီ code နဲ့ reject လုပ်တယ်
const AXIOS_TIMEOUT_CODE = "ECONNABORTED";
// callback က message က်ု customize ပြလို့ရအောင်လုပ်ထားတာ
// callback က undefined ပြန်ရင် ဟိုဘက်မှာတင် format ပြင် ပြီး ပြလိုက်ပြီ ဒီက ဆက်လုပ်စရာမလိုတော့ဘူး
// callback က format ပြင်ပြီး message ပြန်ပေးရင် ဒီဘက် က flash message ပြမယ်
// messageList က frontend error တွေကို locale နဲ့ပြချင်ရင် message list လိုတယ်
const flashErrorMessage = async (error, callback) => {
  console.error(error, callback);

  let errorMessage = getErrorMessage(error);

  if (errorMessage) {
    if (callback && typeof callback === "function") {
      errorMessage = await callback(errorMessage);
    }

    if (errorMessage) {
      // console.log(errorMessage);
      window.toastr.error(errorMessage);
    }
  }
};

const isJson = (str) => {
  try {
    return JSON.parse(str) && !!str;
  } catch (e) {
    return false;
  }
};

const parseJson = (json) => {
  if (isJson(json)) {
    return JSON.parse(json);
  }

  return json;
};

const castToString = (val) => {
  return val + "";
};

const has = (value) => {
  if (value == undefined || value == null) {
    return false;
  }

  if (typeof value == "boolean") {
    return true;
  }

  if (Array.isArray(value)) {
    return value.length > 0;
  }

  if (typeof value == "number") {
    return true;
  }

  if (typeof value == "object") {
    return Object.keys(value).length;
  }

  return !!value;
};

// list = ["name" : { "en": "Hello", "mm" : "ဟယ်လို"}], keys = "name.en"
const getNestedValue = (keys, list, defaultValue) => {
  // defaultValue = defaultValue || typeof defaultValue == 'boolean' ? defaultValue : undefined;

  if (!has(keys) || !has(list)) {
    return defaultValue;
  }

  keys = keys.split(".");

  let key = keys.shift();

  if (keys.length > 0) {
    return getNestedValue(keys.join("."), list[key], defaultValue);
  } else {
    return has(list[key]) ? list[key] : defaultValue;
  }
};

const getLangMessage = (key) => {
  if (!key) {
    return "-";
  }

  let localeMessage = getNestedValue(key, message, key);

  if (localeMessage == key) {
    return key.replace("_", "").toUpperCase();
  }

  return localeMessage;
};

const getErrorMessage = (error) => {
  if (!error) {
    return false;
  }

  let showErrorMessage = "";
  // Servier ဘက်က resonse error အပိုင်း
  if (error.response) {
    let errors = error.response.data.errors;

    if (errors) {
      // server validation error (422)
      // ပထမဦးဆုံး တခုကို ယူ
      let key = Object.keys(errors)[0];

      showErrorMessage = errors[key][0];
    } else {
      // request response error (db error, ....)

      errors = error.response.data.message;

      if (isJson(errors)) {
        return parseJson(errors);
      }

      showErrorMessage = errors;
    }
  } else if (error.isAxiosError) {
    // request ထွက်သွားပေမယ့် response မရောက်လာတာ (network ပြတ်၊ CORS၊ server down၊ timeout)။
    // အရင်က ဒီ error က အောက်က validate.js object branch ထဲ ကျသွားပြီး ပထမ key "config" ကို
    // field name လို ယူလို့ "message.config undefined undefined" ဆိုပြီး toast ပြနေတာ။
    showErrorMessage =
      error.code === AXIOS_TIMEOUT_CODE
        ? trans("connection_timeout")
        : trans("network_error");
  } else {
    // ရိုးရိုး error အပိုင်း

    if (error && Array.isArray(error)) {
      let errorKeys = Object.keys(error);

      let key = trans(errorKeys[0]);
      let value = trans(helper.getNestedValue("errorKeys.0", error, "-"));

      showErrorMessage = `${key} ${value}`;
    } else if (typeof error === "object") {
      // validate.js ကလာတဲ့ error

      let errorKeys = Object.keys(error);

      let name = "";

      // no error to show
      if (errorKeys.length == 0) {
        return false;
      }

      // ပထမဦီးဆုံးတခုကို ယူ
      let errorKey = errorKeys[0];

      // key က dot နဲ့လာမရင် eg . sender.phone နောက်က phone ကိုဘဲယူ

      let keyList = errorKey.split(".");

      if (keyList.length > 1) {
        name = keyList[keyList.length - 1];
      } else {
        name = errorKey;
      }

      let errorMessage = Array.isArray(error[errorKey])
        ? error[errorKey][0]
        : error[errorKey];

      if (typeof errorMessage == "object") {
        let nameLang = trans(name);

        showErrorMessage = `${nameLang} ${trans(errorMessage.lang)}  ${
          errorMessage.value
        } ${trans(errorMessage.suffix)}`;
      } else {
        let nameLang = trans(name);
        let errorMessageLang = trans(errorMessage);

        showErrorMessage = `${nameLang} ${errorMessageLang}`;
      }
    } else {
      showErrorMessage = error;
    }
  }

  return showErrorMessage;
};

const receiveResponse = (response) => {
  if (!response) {
    return response;
  }

  if (response.current_page) {
    return response;
  }

  if (response.data && !response.meta) {
    return receiveResponse(response.data);
  }

  return response;
};

const nestedReceiver = (key, data) => {
  let value = getNestedValue(key, data);

  if (value && getNestedValue(key, value)) {
    return nestedReceiver(key, value);
  }

  return value;
};

const castBool = (data) => {
  if (typeof data === "string") {
    return data === "true";
  }

  return !!data;
};

const sleep = (ms) => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};

const isInDevelop = () => {
  let isLocal = [
    "localhost",
    "fcs.test",
    "fcsbackend.test",
    "fcsmerchant.test",
  ].includes(window.location.hostname);

  let user = store.state.auth.user;

  let isDeveloper =
    user &&
    [
      "techadmin",
      "zawmyohtay",
      "bobo",
      "dev_aung",
      "zadmin",
      "za_cor1",
      "hanni",
      "thidasoe",
      "htetlin",
      "ayemyamon",
      "soehtet",
      "akp",
      "theinteiwai",
    ].includes(user.user_name);

  let result =
    (isLocal || isDeveloper) && localStorage.getItem("developer_mode");

  return castBool(result) ? true : false;
};

const isMe = () => {
  let isLocal = ["localhost", "fcsexpress.test", "fcsbackend.test"].includes(
    window.location.hostname,
  );

  let user = store.state.auth.user;

  let isDeveloper = user && ["dev_aung"].includes(user.user_name);

  return (isLocal || isDeveloper) && localStorage.getItem("developer_mode");
};

const toDate = (dateStr, separator) => {
  if (!separator) {
    if (dateStr.indexOf("/") != -1) {
      separator = ["/"];
    } else {
      separator = ["-"];
    }
  }

  separator.unshift(" ");

  let dateList = splitMultiple(dateStr, separator);

  let time = dateList.length > 3 ? dateList[3].split(":") : "00:00".split(":");

  if (parseInt(dateList[2]) > 1000) {
    return new Date(
      dateList[2],
      dateList[1] - 1,
      dateList[0],
      time[0],
      time[1],
    );
  } else {
    return new Date(
      dateList[0],
      dateList[1] - 1,
      dateList[2],
      time[0],
      time[1],
    );
  }
};

const getFormattedDate = (strDate, format) => {
  if (strDate && strDate.length < 11) {
    // 22/05/2019 အဲ့လို format ဆို 22-05-2019 ကိုပြောင်းမယ်
    strDate = toDate(strDate);
  }

  let date = new Date(strDate).toLocaleString("en-US", {
    timeZone: "Asia/Yangon",
  });

  if (date == "Invalid Date") {
    return strDate;
  }

  if (!format) {
    format = "dd-mm-yyyy";
  }
  try {
    date = dateformat(date, format);
  } catch (e) {
    console.log(e);
  }
  return date;
};

const splitMultiple = (str, arr) => {
  if (!str || arr.length == 0) {
    console.warn("splitMultiple invalid string ", str, arr);
    return [];
  }

  if (arr.length > 1) {
    return splitMultiple(str.split(arr.shift()).join(","), arr);
  }

  return str
    .split(arr.shift())
    .filter((item) => item)
    .join(",")
    .split(",");
};

const toHour = (milli) => {
  return milli / (1000 * 60 * 60);
};

const localeIndex = (num, messageList) => {
  let numArr = String(num).split("");

  numArr = numArr.map((i) => {
    return getNestedValue(i, messageList, i);
    // return getNestedValue(i, messageList, '');
  });

  return numArr.join("");
};

const copy = (id, showMessage = true) => {
  let range;
  let el = typeof id == "string" ? document.getElementById(id) : id;

  if (document.body.createTextRange) {
    range = document.body.createTextRange();
    range.moveToElementText(el);
    range.select();
  } else if (window.getSelection) {
    let selection = window.getSelection();
    range = document.createRange();
    range.selectNodeContents(el);
    selection.removeAllRanges();
    selection.addRange(range);
  }

  try {
    document.execCommand("copy");
    showMessage ? window.toastr.success("Copied!") : "";

    return true;
  } catch (err) {
    return false;
  }
};

const consoleTrace = (isTrace, message) => {
  if (isTrace) {
    console.error(...message);
  }
};

const hasLocale = (word, callback) => {
  return callback(word) != word;
};

const camelize = (str) => {
  return str
    .replace(/(?:^\w|[_]\w|[A-Z]|\b\w)/g, function (word, index) {
      return index === 0
        ? word.toLowerCase()
        : word[0] == "_"
        ? word[1].toUpperCase()
        : word.toUpperCase();
    })
    .replace(/\s+/g, "");
};

const getRegionSlug = (regionName) => {
  return constants.region_slug[regionName];
};

const currencyAIFormat = (value) => {
  if (value < 1000) {
    return value;
  }

  if (value < 100000) {
    return (value / 1000).toString() + " K";
  } else if (value < 1000000) {
    return (value / 100000).toString() + " L";
  } else {
    return (value / 1000000).toString() + " M";
  }
};

const isNum = (value) => {
  if (value == 0) {
    return true;
  }

  return castToNumber(value);
};

const translateLocale = (value, messageList) => {
  if (isNum(value)) {
    return localeIndex(value, messageList);
  } else {
    return translate(value);
  }
};

const translate = (message, params = []) => {
  return message ? trans(message, ...params) : message;
};

const castToNumber = (num) => {
  let result = parseFloat(num);

  result = isNaN(result) ? 0 : result;

  return result;
};

/**
 *
 * @param {*} url
 * @param {*} query
 * @returns Promise
 *
 * ဒီဟာက url နဲ့ query နဲ့ ထည့်လိုက်ရင် pull ဆွဲပြီး promise return ပြန်ပေးတယ် ၂ ခါမဆွဲဘူး
 * Store ထဲသိမ်းမယ့်ဟာတွေဘဲသုံးရန်
 */
const pullingStateManipulator = (url, query) => {
  let cacheKey = store.getters["cache/generateKey"]({
    url: url,
    params: query,
  });

  let data = store.getters["cache/getList"](url, query);

  if (data && has(data)) {
    return new Promise((resolve, reject) => {
      resolve(data);
    });
  } else if (store.getters["cache/getPullingState"](url, query)) {
    return store.getters["cache/getPromise"](url, query);
  } else {
    let promise = api.puller(url, query);

    store.dispatch("cache/set_pulling_state", {
      key: cacheKey,
      value: true,
    });

    store.dispatch("cache/set_promise", {
      key: cacheKey,
      value: promise,
    });

    promise
      .then((response) => {
        store.dispatch("cache/set_list", {
          key: cacheKey,
          value: response.data,
        });
      })
      .finally(() => {
        store.dispatch("cache/set_pulling_state", {
          key: cacheKey,
          value: false,
        });

        store.dispatch("cache/set_promise", {
          key: cacheKey,
          value: null,
        });
      });

    return promise;
  }
};

const assignObject = (from, to) => {
  let keys = Object.keys(from);

  keys.map((key) => {
    if (
      from[key] != null &&
      typeof from[key] == "object" &&
      !Array.isArray(from[key])
    ) {
      if (to[key] && typeof to[key] == "object") {
        Object.assign(to, {
          [key]: assignObject(from[key], to[key]),
        });
      } else {
        if (from[key]) {
          if (!to) {
            // to က undefined
            to = {}; // initialize;
          }

          Object.assign(to, {
            [key]: from[key],
          });
        }
      }
    } else {
      Object.assign(to, {
        [key]: from[key],
      });
    }
  });

  return to;
};

const addUserHashPayload = (payload) => {
  let user = store.state.auth.user;
  return assignObject({ [`hashid`]: getNestedValue("hashid", user) }, payload);
};

const uniqueArray = (array) => Array.from(new Set(array));

const getPermissionsStringOfRouteList = (current_route_list) => {
  if (!Array.isArray(current_route_list)) {
    console.error("current_route_list is not an array");
    return "";
  }

  return uniqueArray(
    current_route_list
      .map((route) => {
        let permissionObj = route.meta.permissions;

        let permissions =
          typeof permissionObj == "string"
            ? [permissionObj]
            : Object.values(permissionObj);

        return permissions;
      })
      .flat(1),
  ).join(", ");
};

export default {
  toHour,
  has,
  getNestedValue,
  castToString,
  parseJson,
  isJson,
  flashErrorMessage,
  getLangMessage,
  getErrorMessage,
  receiveResponse,
  nestedReceiver,
  isInDevelop,
  getFormattedDate,
  toDate,
  splitMultiple,
  localeIndex,
  sleep,
  copy,
  consoleTrace,
  hasLocale,
  camelize,
  getRegionSlug,
  currencyAIFormat,
  isNum,
  translateLocale,
  castToNumber,
  translate,
  pullingStateManipulator,
  isMe,
  assignObject,
  addUserHashPayload,
  castBool,
  getPermissionsStringOfRouteList,
};
